import { useQuery } from '@tanstack/react-query';
import { warrantyApi } from '@/features/warranties/api/warrantyApi';

/**
 * Hook pour récupérer les détails complets d'une garantie
 */
export const useWarrantyDetails = (warrantyUuid?: string) => {
  return useQuery({
    queryKey: ['warranty', warrantyUuid],
    queryFn: () => warrantyApi.getWarranty(warrantyUuid!),
    enabled: !!warrantyUuid,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
